import { Component, OnInit } from '@angular/core';
import { HeaderTitleService } from 'app/services/header-title.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {
  url = environment.helpScoutUrl;

  constructor(private headerService: HeaderTitleService) { }

  ngOnInit() {
    this.sendHeaders();
  }

  sendHeaders(): void {
    this.headerService.sendHeader('support', 'Help Center')
  }

}



// WEBPACK FOOTER //
// ./src/app/main/content/help/help.component.ts